"use strict";
// tslint:disable
/**
 * Speedtest Plus API
 * This is the API for Speedtest Plus
 *
 * The version of the OpenAPI document: 0.46.0
 * Contact: speedtest-api@anw.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = void 0;
const runtime_1 = require("../runtime");
/**
 * no description
 */
class DefaultApi extends runtime_1.BaseAPI {
    abort({ xAPIKEY, abortRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'abort');
        (0, runtime_1.throwIfNullOrUndefined)(abortRequestModel, 'abortRequestModel', 'abort');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/abort/',
            method: 'PUT',
            headers,
            body: abortRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    backgroundRadioStats({ xAPIKEY, backgroundRadioStatsModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'backgroundRadioStats');
        (0, runtime_1.throwIfNullOrUndefined)(backgroundRadioStatsModel, 'backgroundRadioStatsModel', 'backgroundRadioStats');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/backgroundRadioStats/',
            method: 'POST',
            headers,
            body: backgroundRadioStatsModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    calcBenchmark({ xAPIKEY, calcBenchmarkRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'calcBenchmark');
        (0, runtime_1.throwIfNullOrUndefined)(calcBenchmarkRequestModel, 'calcBenchmarkRequestModel', 'calcBenchmark');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/calc/benchmark/',
            method: 'PUT',
            headers,
            body: calcBenchmarkRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    calcDownload({ xAPIKEY, calcDownloadRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'calcDownload');
        (0, runtime_1.throwIfNullOrUndefined)(calcDownloadRequestModel, 'calcDownloadRequestModel', 'calcDownload');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/calc/download/',
            method: 'PUT',
            headers,
            body: calcDownloadRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    calcPageSpeed({ xAPIKEY, calcPageSpeedRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'calcPageSpeed');
        (0, runtime_1.throwIfNullOrUndefined)(calcPageSpeedRequestModel, 'calcPageSpeedRequestModel', 'calcPageSpeed');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/calc/pageSpeed/',
            method: 'PUT',
            headers,
            body: calcPageSpeedRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    calcPing({ xAPIKEY, calcPingRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'calcPing');
        (0, runtime_1.throwIfNullOrUndefined)(calcPingRequestModel, 'calcPingRequestModel', 'calcPing');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/calc/ping/',
            method: 'PUT',
            headers,
            body: calcPingRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    calcUpload({ xAPIKEY, calcUploadRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'calcUpload');
        (0, runtime_1.throwIfNullOrUndefined)(calcUploadRequestModel, 'calcUploadRequestModel', 'calcUpload');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/calc/upload/',
            method: 'PUT',
            headers,
            body: calcUploadRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    complete({ xAPIKEY, completeRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'complete');
        (0, runtime_1.throwIfNullOrUndefined)(completeRequestModel, 'completeRequestModel', 'complete');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/complete/',
            method: 'PUT',
            headers,
            body: completeRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    configGet({ xAPIKEY }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'configGet');
        const headers = Object.assign({}, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/config/',
            method: 'GET',
            headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    consentManagement({ xAPIKEY, consentManagementModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'consentManagement');
        (0, runtime_1.throwIfNullOrUndefined)(consentManagementModel, 'consentManagementModel', 'consentManagement');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/consentManagement/',
            method: 'POST',
            headers,
            body: consentManagementModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    faq({ xAPIKEY }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'faq');
        const headers = Object.assign({}, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/faq/',
            method: 'GET',
            headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    generateReport({ xAPIKEY, printRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'generateReport');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/print/',
            method: 'POST',
            headers,
            body: printRequestModel,
            responseType: 'blob',
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    initialize({ xAPIKEY, initRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'initialize');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/init/',
            method: 'POST',
            headers,
            body: initRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    modem({ xAPIKEY, speedtestId }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'modem');
        (0, runtime_1.throwIfNullOrUndefined)(speedtestId, 'speedtestId', 'modem');
        const headers = Object.assign({}, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/modem/{speedtestId}'.replace('{speedtestId}', (0, runtime_1.encodeURI)(speedtestId)),
            method: 'GET',
            headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    speedtestSpeedtestIdGet({ xAPIKEY, speedtestId }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'speedtestSpeedtestIdGet');
        (0, runtime_1.throwIfNullOrUndefined)(speedtestId, 'speedtestId', 'speedtestSpeedtestIdGet');
        const headers = Object.assign({}, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/speedtest/{speedtestId}'.replace('{speedtestId}', (0, runtime_1.encodeURI)(speedtestId)),
            method: 'GET',
            headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    tips({ xAPIKEY, speedtestId }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'tips');
        (0, runtime_1.throwIfNullOrUndefined)(speedtestId, 'speedtestId', 'tips');
        const headers = Object.assign({}, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/tips/{speedtestId}'.replace('{speedtestId}', (0, runtime_1.encodeURI)(speedtestId)),
            method: 'GET',
            headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    tipsKeys({ xAPIKEY, speedtestId }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'tipsKeys');
        (0, runtime_1.throwIfNullOrUndefined)(speedtestId, 'speedtestId', 'tipsKeys');
        const headers = Object.assign({}, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/tipsKeys/{speedtestId}'.replace('{speedtestId}', (0, runtime_1.encodeURI)(speedtestId)),
            method: 'GET',
            headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
    updateValue({ xAPIKEY, valueRequestModel }, opts) {
        (0, runtime_1.throwIfNullOrUndefined)(xAPIKEY, 'xAPIKEY', 'updateValue');
        const headers = Object.assign({ 'Content-Type': 'application/json' }, (xAPIKEY != null ? { 'X-APIKEY': String(xAPIKEY) } : undefined));
        // @ts-ignore The generator is probably incompatible with the used version of rxjs. TODO: Remove the generated API and implement manually
        return this.request({
            url: '/values/',
            method: 'POST',
            headers,
            body: valueRequestModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    }
    ;
}
exports.DefaultApi = DefaultApi;
//# sourceMappingURL=DefaultApi.js.map